import * as React from "react";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Link from "@mui/material/Link";
import ButtonBase from "@mui/material/ButtonBase";
import Container from "@mui/material/Container";
import Typography from "../components/Typography";
import GakuseiGuildImage from "../../assets/GakuseiGuild.png"
import ProfileImage from "../../assets/Profile.JPG"
import StreamImage from "../../assets/robot.jpg"
import FacebookImage from "../../assets/facebook.png"
import YoutubeImage from "../../assets/Youtube.jpeg"

const ImageBackdrop = styled("div")(({ theme }) => ({
  position: "absolute",
  left: 0,
  right: 0,
  top: 0,
  bottom: 0,
  background: "#000",
  opacity: 0.5,
  transition: theme.transitions.create("opacity"),
}));

const ImageIconButton = styled(ButtonBase)(({ theme }) => ({
  position: "relative",
  display: "block",
  padding: 0,
  borderRadius: 0,
  height: "40vh",
  [theme.breakpoints.down("md")]: {
    width: "100% !important",
    height: 100,
  },
  "&:hover": {
    zIndex: 1,
  },
  "&:hover .imageBackdrop": {
    opacity: 0.15,
  },
  "&:hover .imageMarked": {
    opacity: 0,
  },
  "&:hover .imageTitle": {
    border: "4px solid currentColor",
  },
  "& .imageTitle": {
    position: "relative",
    padding: `${theme.spacing(2)} ${theme.spacing(4)} 14px`,
  },
  "& .imageMarked": {
    height: 3,
    width: 18,
    background: theme.palette.common.white,
    position: "absolute",
    bottom: -2,
    left: "calc(50% - 9px)",
    transition: theme.transitions.create("opacity"),
  },
}));

const images = [
  {
    img: ProfileImage,
    title: "講師プロフィール・実績",
    width: "50%",
    href: "https://www.linkedin.com/in/minaesuzuki",
  },
  {
    img: FacebookImage,
    title: "Facebook",
    width: "50%",
    href: "https://www.facebook.com/profile.php?id=100009423419067",
  },
  {
    img: YoutubeImage,
    title: "YouTube",
    width: "50%",
    href: "https://www.youtube.com/channel/UCpXZr9qzav3ue72dOGoysaw/featured",
  },
  {
    img: GakuseiGuildImage,
    title: "合同会社学生ギルド",
    width: "50%",
    href: "https://gakuseiguild.co.jp/",
  },
  {
    img: StreamImage,
    title: "オンラインものづくり教室STREAM",
    width: "100%",
    href: "https://stream.gakuseiguild.co.jp/",
  },
];

export default function ProductCategories() {
  return (
    <Container component="section" sx={{ mt: 8, mb: 4 }}>
      <Typography variant="h4" marked="center" align="center" component="h2">
        あなたの学びに明かりを灯す
      </Typography>
      <Box sx={{ mt: 8, display: "flex", flexWrap: "wrap" }}>
        {images.map((image) => (
          <ImageIconButton
            key={image.title}
            style={{
              width: image.width,
            }}
            href={image.href}
            target="_blank"
          >
            <Box
              sx={{
                position: "absolute",
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                backgroundSize: "cover",
                backgroundPosition: "center 40%",
                backgroundImage: `url(${image.img})`,
              }}
            />
            <ImageBackdrop className="imageBackdrop" />
            <Box
              sx={{
                position: "absolute",
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "common.white",
              }}
            >
              <Typography
                component="h3"
                variant="h6"
                color="inherit"
                className="imageTitle"
              >
                {image.title}
                <div className="imageMarked" />
              </Typography>
            </Box>
          </ImageIconButton>
        ))}
      </Box>
    </Container>
  );
}
